import { render, staticRenderFns } from "./editarClienteForm.vue?vue&type=template&id=7c4c501a"
import script from "./editarClienteForm.vue?vue&type=script&lang=js"
export * from "./editarClienteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports